import { render, staticRenderFns } from "./groupConsignment.vue?vue&type=template&id=f89366a4&"
import script from "./groupConsignment.vue?vue&type=script&lang=js&"
export * from "./groupConsignment.vue?vue&type=script&lang=js&"
import style0 from "./groupConsignment.vue?vue&type=style&index=0&id=f89366a4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports